import React from "react";

const popularCars = [
  {
    name: "DZIRE",
    image: "/images/ourfleets/1.jpg",
    description:
      "The Maruti Suzuki Dzire is a compact sedan that’s perfect for city commutes and intercity travel. With seating for 4 passengers and excellent mileage (up to 25 km/l), it’s an affordable and comfortable choice for daily cab services.",
    doors: "4 Doors",
    suitcase: "1 Large, 2 Small",
    passengers: "04",
  },
  {
    name: "ETIOS",
    image: "/images/ourfleets/ETIOS.jpg",
    description:
      "Toyota Etios offers a smooth and spacious ride, ideal for long-distance journeys and airport transfers. Known for its reliability and ample luggage space, it’s a popular sedan choice in the taxi segment, even after discontinuation.",
    doors: "4 Doors",
    suitcase: "1 Large, 2 Small",
    passengers: "04",
  },
  {
    name: "XCENT",
    image: "/images/ourfleets/XCENT.jpg",
    description:
      "Hyundai Xcent is a compact and fuel-efficient sedan, best suited for local city rides and airport pickups. With comfortable interiors and good mileage, it remains a smart choice for short-distance travel.",
    doors: "4 Doors",
    suitcase: "1 Large, 2 Small",
    passengers: "04",
  },
  {
    name: "ERTIGA",
    image: "/images/ourfleets/4.jpg",
    description:
      "The Maruti Suzuki Ertiga is a 7-seater MUV, perfect for family trips, group travel, and outstation tours. With flexible luggage space and CNG options, it delivers great comfort and economy for longer journeys.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "07",
  },
  {
    name: "INNOVA",
    image: "/images/ourfleets/7.jpg",
    description:
      "Toyota Innova is India’s most trusted MUV for comfortable and spacious travel. Ideal for outstation rides and tourist trips, it offers excellent seating, ample luggage space, and a smooth ride across long distances.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "07",
  },
  {
    name: "INNOVA CRYSTA",
    image: "/images/ourfleets/5.jpg",
    description:
      "The Innova Crysta adds a premium touch to group travel with luxurious interiors, advanced features, and powerful performance. It’s the top choice for executive rides, business travel, and family tours in absolute comfort.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "07",
  },
];


const PopularCarsSection = () => {
  return (
    <section className="popular-car-section  grey-bg">
      <div className="container">
        {/* Section title */}
        <div className="section-title centred mb_60">
          <span className="sub-title">Sai Trupti Cabs</span>
          <h2 className="title">Most Popular Cars</h2>
        </div>

        {/* Cars Grid */}
        <div className="row">
          {popularCars.map((car, index) => (
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
              key={index}
            >
              <div className="single-popular-car-block Popular">
                <div className="single-popular-car-image">
                  <img src={car.image} alt={car.name} />
                  
                </div>

                <div className="single-popular-car-content">
                  {/* <div className="single-popular-car-rating">
                    <i className="icon-9"></i>
                    {car.rating}
                  </div> */}
                  <h5 className="single-popular-car-title">{car.name}</h5>
                  <p className="single-popular-car-text">{car.description}</p>

                  <div className="border-divider"></div>

                  <ul className="single-popular-car-info">
                    <li>
                      <i className="icon-6"></i>Doors: {car.doors}
                    </li>
                    <li>
                      <i className="icon-7"></i>Suitcase: {car.suitcase}
                    </li>
                    <li>
                      <i className="icon-8"></i>Passengers: {car.passengers}
                    </li>
                  </ul>

                  <div className="single-popular-car-book-btn">
                    <a href="#" className="btn-style-three">
                      Book now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularCarsSection;


// import React from "react";
// import { Link } from "react-router-dom"; // ✅ Import React Router Link

// const cars = [
//   {
//     name: "DZIRE",
//     image: "/images/ourfleets/1.jpg",
//     rating: 5.0,
//     description:
//       "The Maruti Suzuki Dzire is a compact sedan that’s perfect for city commutes and intercity travel. With seating for 4 passengers and excellent mileage (up to 25 km/l), it’s an affordable and comfortable choice for daily cab services.",
//     local: "Local 8 Hrs / 80 KM : ₹ 2000 /-",
//     extraKm: "Extra KM : ₹ 12 /-",
//     extraHr: "Extra HR : ₹ 150 /-",
//   },
//   {
//     name: "ETIOS",
//     image: "/images/ourfleets/ETIOS.jpg",
//     rating: 4.9,
//     description:
//       "Toyota Etios offers a smooth and spacious ride, ideal for long-distance journeys and airport transfers. Known for its reliability and ample luggage space, it’s a popular sedan choice in the taxi segment, even after discontinuation.",
//     local: "Local 8 Hrs / 80 KM : ₹ 2000 /-",
//     extraKm: "Extra KM : ₹ 12 /-",
//     extraHr: "Extra HR : ₹ 150 /-",
//   },
//   {
//     name: "XCENT",
//     image: "/images/ourfleets/XCENT.jpg",
//     rating: 4.7,
//     description:
//       "Hyundai Xcent is a compact and fuel-efficient sedan, best suited for local city rides and airport pickups. With comfortable interiors and good mileage, it remains a smart choice for short-distance travel.",
//     local: "Local 8 Hrs / 80 KM : ₹ 2000 /-",
//     extraKm: "Extra KM : ₹ 12 /-",
//     extraHr: "Extra HR : ₹ 150 /-",
//   },
//   {
//     name: "ERTIGA",
//     image: "/images/ourfleets/4.jpg",
//     rating: 4.8,
//     description:
//       "The Maruti Suzuki Ertiga is a 7-seater MUV, perfect for family trips, group travel, and outstation tours. With flexible luggage space and CNG options, it delivers great comfort and economy for longer journeys.",
//     local: "Local 8 Hrs / 80 KM : ₹ 2500 /-",
//     extraKm: "Extra KM : ₹ 14 /-",
//     extraHr: "Extra HR : ₹ 200 /-",
//   },
//   {
//     name: "INNOVA",
//     image: "/images/ourfleets/7.jpg",
//     rating: 4.5,
//     description:
//       "Toyota Innova is India’s most trusted MUV for comfortable and spacious travel. Ideal for outstation rides and tourist trips, it offers excellent seating, ample luggage space, and a smooth ride across long distances.",
//     local: "Local 8 Hrs / 80 KM : ₹ 2700 /-",
//     extraKm: "Extra KM : ₹ 17 /-",
//     extraHr: "Extra HR : ₹ 200 /-",
//   },
//   {
//     name: "INNOVA CRYSTA",
//     image: "/images/ourfleets/5.jpg",
//     rating: 4.8,
//     description:
//       "The Innova Crysta adds a premium touch to group travel with luxurious interiors, advanced features, and powerful performance. It’s the top choice for executive rides, business travel, and family tours in absolute comfort.",
//     local: "Local 8 Hrs / 80 KM : ₹ 3300 /-",
//     extraKm: "Extra KM : ₹ 19 /-",
//     extraHr: "Extra HR : ₹ 250 /-",
//   },
// ];

// const PopularCarsSection = () => (
//   <section className="popular-cars-section">
//     <div className="container">
//       <div className="section-title text-center">
//         <span className="sub-title">Sai Trupti Cabs</span>
//         <h2 className="title">Most Popular Cars</h2>
//       </div>

//       <div className="car-grid">
//         {cars.map((car, i) => (
//           <div key={i} className="car-card">
//             <img src={car.image} alt={car.name} className="car-img" />

//             <div className="car-content">
//               <div className="car-header">
//                 <h4>{car.name}</h4>
//                 <div className="car-rating">⭐ {car.rating}</div>
//               </div>

//               <p className="car-desc">{car.description}</p>
//               <hr />

//               <ul className="car-details">
//                 <li>🚖 {car.local}</li>
//                 <li>🚖 {car.extraKm}</li>
//                 <li>🚖 {car.extraHr}</li>
//               </ul>

//               {/* ✅ Correct navigation using React Router */}
//               <Link to="/booking" className="book-btn text-center">
//                 Book Now
//               </Link>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   </section>
// );

// export default PopularCarsSection;
